import { Content } from '@carbon/react';
import cx from 'clsx';

import Footer from 'features/layout/Footer';
import Header from 'features/layout/Header';
import styles from 'theme/features/layout/layout.module.scss';

const Layout = ({ children, noPadding = false }) => (
  <>
    <Header />
    <Content className={cx(styles.content, noPadding && styles['content--no-padding'])}>{children}</Content>
    <Footer />
  </>
);

export default Layout;
